import i18n from '../../locale/i18n';
import React, { lazy, Suspense, useEffect } from 'react';
import { Col, Image, Row, Card } from 'antd';
import { WizardCard } from '../../components/common/cards';
import { WIZARD_CARD_PRESETS } from '../../components/common/cards/WizardCard/WizardCard.config';

// Function for adding styles (no longer used)
const addRotationStyles = () => {
  // Animations disabled
};

import { MoreOutlined } from '@ant-design/icons';
import { PageTitle } from '../../components/common/PageTitle/PageTitle';
import { useResponsive } from '../../hooks/useResponsive';
import { ClassCard } from '../../components/classes/ClassCard/ClassCard';
import { CreateClassForm } from '../../components/forms/CreateClassForm/CreateClassForm';
import { useTranslation } from 'react-i18next';
//import { Card } from '../../components/common/Card/Card';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useActions } from '../../hooks/useActions';
import { useDispatch } from 'react-redux';
import { useNavigation, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { AnswerSheetsTable } from '../../components/tables/AnswerSheet/AnswerSheetsTable/AnswerSheetsTable';
import { AnswerSheetView } from '../../components/answer_sheets/AnswerSheetView/AnswerSheetView';
import { Button } from '../../components/common/buttons/Button/Button';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { notificationController } from '../../controllers/notificationController';
import { AssessmentsTable } from '../../components/tables/Assessment/AssessmentsTable/AssessmentsTable';

import DeleteIcon from '@mui/icons-material/Delete';
import AddCardIcon from '@mui/icons-material/AddCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Container, Grid, IconButton } from '@mui/material';
import { Popconfirm } from '../../components/common/Popconfirm/Popconfirm';
import { IAssessmentsState } from '../../store/reducers/assessments/types';
import { DefaultView } from '../../components/DefaultView/DefaultView';
import { AssessmentView } from '../../components/assessments/AssessmentView/AssessmentView';
import step_1 from '../../assets/images/wizard_step_1.svg';
import step_2 from '../../assets/images/wizard_step_2.svg';
import step_3 from '../../assets/images/wizard_step_3.svg';
import step_4 from '../../assets/images/wizard_step_4.svg';
import step_5 from '../../assets/images/wizard_step_5.svg';
import one from '../../assets/images/one.svg';
import two from '../../assets/images/two.svg';
import three from '../../assets/images/three.svg';
import four from '../../assets/images/four.svg';
import five from '../../assets/images/five.svg';
import ellipseLeft from '../../assets/images/ellipse_left.svg';
import ellipseRight from '../../assets/images/ellipse_right.svg';

const MKTypography = lazy(() => import('../../components/layouts/HomeLayout/components/MKTypography'));

function WizardPage() {
  const { isMobile, isTablet, isDesktop, mobileOnly } = useResponsive();
  const { t } = useTranslation();

  // Add animation styles when component loads
  useEffect(() => {
    addRotationStyles();
  }, []);

  // Arrow component for desktop
  const RightArrow = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 30px',
      position: 'relative'
    }}>
      <svg width="80" height="60" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Glow effect background */}
        <ellipse cx="40" cy="30" rx="35" ry="20" fill="url(#glowGradient)" opacity="0.3">
          <animate attributeName="opacity" values="0.2;0.4;0.2" dur="2s" repeatCount="indefinite" />
        </ellipse>
        
        {/* Main arrow path with dashed style */}
        <path 
          d="M8 30 Q20 30 30 30 T55 30" 
          stroke="url(#arrowGradient)" 
          strokeWidth="2.5" 
          strokeLinecap="round"
          strokeDasharray="4 3"
          opacity="0.6"
        >
          <animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.5s" repeatCount="indefinite" />
        </path>
        
        {/* Main solid arrow line */}
        <path 
          d="M10 30 L58 30" 
          stroke="url(#arrowGradient)" 
          strokeWidth="3" 
          strokeLinecap="round"
        />
        
        {/* Arrow head with gradient fill */}
        <path 
          d="M58 30 L50 24 L52 30 L50 36 Z" 
          fill="url(#arrowGradient)"
          stroke="url(#arrowGradient)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; 3 0; 0 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </path>
        
        {/* Animated dots along the path */}
        <circle r="2" fill="#21cbf3">
          <animateMotion dur="2s" repeatCount="indefinite" path="M10 30 L58 30" />
          <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
        </circle>
        
        <defs>
          <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1976d2" />
            <stop offset="50%" stopColor="#2196f3" />
            <stop offset="100%" stopColor="#21cbf3" />
          </linearGradient>
          <radialGradient id="glowGradient">
            <stop offset="0%" stopColor="#21cbf3" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#1976d2" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );

  const desktopLayout = (
    <div>
      <Row gutter={[20, 20]}>
          <Col span={24}>
            {/* Title and description */}
            <Row style={{ marginBottom: '2rem', marginTop: '1rem' }}>
              <Container>
                <Grid container item xs={12} lg={10} justifyContent="center" mx="auto">
                  <MKTypography
                    variant="h4"
                    textAlign="center"
                  >
                    {i18n.t('wizard:title')}
                  </MKTypography>
                  <MKTypography
                    variant="body2"
                    textAlign="center"
                    px={{ xs: 2, lg: 4 }}
                  >
                    {i18n.t('wizard:description')}
                  </MKTypography>
                </Grid>
              </Container>
            </Row>

            {/* Central Wizard Badge */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '50px'
            }}>
              <div style={{
                width: '140px',
                height: '140px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                boxShadow: '0 0 25px rgba(0, 255, 255, 0.2), 0 12px 36px rgba(0, 0, 0, 0.12)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                border: '3px solid #1976d2'
              }}>
                <MKTypography variant="h4" style={{ color: '#1976d2', fontWeight: 800, fontSize: '22px', marginBottom: '4px' }}>
                  Wizard
                </MKTypography>
                <MKTypography variant="body1" style={{ color: '#666', fontSize: '13px', fontWeight: 500 }}>
                  Process Flow
                </MKTypography>
                <div style={{
                  width: '35px',
                  height: '2px',
                  background: 'linear-gradient(90deg, #1976d2, #21cbf3)',
                  marginTop: '6px',
                  borderRadius: '1px'
                }} />
              </div>
            </div>

            {/* First row - Cards 1, 2, 3 with arrows */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '40px',
              flexWrap: 'nowrap'
            }}>
              <WizardCard
                mainImage={step_1}
                stepImage={one}
                titleKey="wizard:card1Title"
                descriptionKey="wizard:card1Description"
                colorScheme={WIZARD_CARD_PRESETS.step1.colorScheme}
                rotation={0}
                orbitRadius={0}
                width={260}
              />
              <RightArrow />
              <WizardCard
                mainImage={step_2}
                stepImage={two}
                titleKey="wizard:card2Title"
                descriptionKey="wizard:card2Description"
                colorScheme={WIZARD_CARD_PRESETS.step2.colorScheme}
                rotation={0}
                orbitRadius={0}
                width={260}
              />
              <RightArrow />
              <WizardCard
                mainImage={step_3}
                stepImage={three}
                titleKey="wizard:card3Title"
                descriptionKey="wizard:card3Description"
                colorScheme={WIZARD_CARD_PRESETS.step3.colorScheme}
                rotation={0}
                orbitRadius={0}
                width={260}
              />
            </div>

            {/* Second row - Cards 4, 5 with arrow */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '40px',
              flexWrap: 'nowrap'
            }}>
              <WizardCard
                mainImage={step_4}
                stepImage={four}
                titleKey="wizard:card4Title"
                descriptionKey="wizard:card4Description"
                colorScheme={WIZARD_CARD_PRESETS.step4.colorScheme}
                rotation={0}
                orbitRadius={0}
                width={260}
              />
              <RightArrow />
              <WizardCard
                mainImage={step_5}
                stepImage={five}
                titleKey="wizard:card5Title"
                descriptionKey="wizard:card5Description"
                colorScheme={WIZARD_CARD_PRESETS.step5.colorScheme}
                rotation={0}
                orbitRadius={0}
                width={260}
              />
            </div>
          </Col>
        </Row>
    </div>
  );

  // Arrow component for mobile (pointing down)
  const DownArrow = () => (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '20px 0',
      position: 'relative'
    }}>
      <svg width="60" height="70" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Glow effect background */}
        <ellipse cx="30" cy="35" rx="20" ry="30" fill="url(#glowGradientMobile)" opacity="0.3">
          <animate attributeName="opacity" values="0.2;0.4;0.2" dur="2s" repeatCount="indefinite" />
        </ellipse>
        
        {/* Main arrow path with dashed style */}
        <path 
          d="M30 8 Q30 20 30 30 T30 52" 
          stroke="url(#arrowGradientMobile)" 
          strokeWidth="2.5" 
          strokeLinecap="round"
          strokeDasharray="4 3"
          opacity="0.6"
        >
          <animate attributeName="stroke-dashoffset" from="0" to="-14" dur="1.5s" repeatCount="indefinite" />
        </path>
        
        {/* Main solid arrow line */}
        <path 
          d="M30 10 L30 54" 
          stroke="url(#arrowGradientMobile)" 
          strokeWidth="3" 
          strokeLinecap="round"
        />
        
        {/* Arrow head with gradient fill */}
        <path 
          d="M30 54 L24 46 L30 48 L36 46 Z" 
          fill="url(#arrowGradientMobile)"
          stroke="url(#arrowGradientMobile)"
          strokeWidth="1.5"
          strokeLinejoin="round"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; 0 3; 0 0"
            dur="1.5s"
            repeatCount="indefinite"
          />
        </path>
        
        {/* Animated dots along the path */}
        <circle r="2.5" fill="#21cbf3">
          <animateMotion dur="2s" repeatCount="indefinite" path="M30 10 L30 54" />
          <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite" />
        </circle>
        
        <defs>
          <linearGradient id="arrowGradientMobile" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1976d2" />
            <stop offset="50%" stopColor="#2196f3" />
            <stop offset="100%" stopColor="#21cbf3" />
          </linearGradient>
          <radialGradient id="glowGradientMobile">
            <stop offset="0%" stopColor="#21cbf3" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#1976d2" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );

  const mobileLayout = (
    <div style={{ padding: '20px' }}>
      {/* Title and description */}
      <div style={{ marginBottom: '30px', textAlign: 'center' }}>
        <MKTypography
          variant="h4"
          textAlign="center"
          style={{ marginBottom: '16px' }}
        >
          {i18n.t('wizard:title')}
        </MKTypography>
        <MKTypography
          variant="body2"
          textAlign="center"
          style={{ padding: '0 16px' }}
        >
          {i18n.t('wizard:description')}
        </MKTypography>
      </div>

      {/* Central Wizard Badge */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '30px'
      }}>
        <div style={{
          width: '120px',
          height: '120px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          boxShadow: '0 0 20px rgba(0, 255, 255, 0.2), 0 12px 32px rgba(0, 0, 0, 0.12)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          border: '3px solid #1976d2'
        }}>
          <MKTypography variant="h4" style={{ color: '#1976d2', fontWeight: 800, fontSize: '20px', marginBottom: '4px' }}>
            Wizard
          </MKTypography>
          <MKTypography variant="body1" style={{ color: '#666', fontSize: '12px', fontWeight: 500 }}>
            Process Flow
          </MKTypography>
          <div style={{
            width: '30px',
            height: '2px',
            background: 'linear-gradient(90deg, #1976d2, #21cbf3)',
            marginTop: '6px',
            borderRadius: '1px'
          }} />
        </div>
      </div>

      <DownArrow />

      {/* Cards stacked vertically with arrows */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <WizardCard
          mainImage={step_1}
          stepImage={one}
          titleKey="wizard:card1Title"
          descriptionKey="wizard:card1Description"
          colorScheme={WIZARD_CARD_PRESETS.step1.colorScheme}
          rotation={0}
          orbitRadius={0}
        />

        <DownArrow />

        <WizardCard
          mainImage={step_2}
          stepImage={two}
          titleKey="wizard:card2Title"
          descriptionKey="wizard:card2Description"
          colorScheme={WIZARD_CARD_PRESETS.step2.colorScheme}
          rotation={0}
          orbitRadius={0}
        />

        <DownArrow />

        <WizardCard
          mainImage={step_3}
          stepImage={three}
          titleKey="wizard:card3Title"
          descriptionKey="wizard:card3Description"
          colorScheme={WIZARD_CARD_PRESETS.step3.colorScheme}
          rotation={0}
          orbitRadius={0}
        />

        <DownArrow />

        <WizardCard
          mainImage={step_4}
          stepImage={four}
          titleKey="wizard:card4Title"
          descriptionKey="wizard:card4Description"
          colorScheme={WIZARD_CARD_PRESETS.step4.colorScheme}
          rotation={0}
          orbitRadius={0}
        />

        <DownArrow />

        <WizardCard
          mainImage={step_5}
          stepImage={five}
          titleKey="wizard:card5Title"
          descriptionKey="wizard:card5Description"
          colorScheme={WIZARD_CARD_PRESETS.step5.colorScheme}
          rotation={0}
          orbitRadius={0}
        />
      </div>
    </div>
  );
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {mobileOnly ? mobileLayout : desktopLayout}
    </Suspense>
  );
};

export default WizardPage